// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1JddN","name":"Header_name__3FreQ","birthday":"Header_birthday__20-oN","skeleton":"Header_skeleton__3_TSK"};